module["exports"] = [
  "do Descoberto",
  "de Nossa Senhora",
  "do Norte",
  "do Sul"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/address/city_suffix.js
// module id = 1233
// module chunks = 0